import { Link } from 'react-router-dom';
import React from 'react';
import { greenTextColor } from '../main/react/App';

const TextLink = ({
  label,
  to,
  externalLink = false,
  divStyle = {},
  color = greenTextColor,
  title,
}: {
  label: string;
  to: string;
  externalLink?: boolean;
  divStyle?: React.CSSProperties;
  color?: string;
  title?: string;
}) => (
  <div style={divStyle}>
    {!externalLink ? (
      <Link to={to} style={{ textDecoration: 'none', color }} title={title}>
        {label}
      </Link>
    ) : (
      <Link
        to={{ pathname: to }}
        target="_blank"
        style={{ textDecoration: 'none', color }}
        title={title}
      >
        {label}
      </Link>
    )}
  </div>
);

export default TextLink;
